import { render, staticRenderFns } from "./newsmenu-list.vue?vue&type=template&id=22da1aec&scoped=true&"
import script from "./newsmenu-list.vue?vue&type=script&lang=js&"
export * from "./newsmenu-list.vue?vue&type=script&lang=js&"
import style0 from "./newsmenu-list.vue?vue&type=style&index=0&id=22da1aec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22da1aec",
  null
  
)

export default component.exports